/**
 * Feature flags — centralized config.
 * Read from environment, default to dev-friendly values.
 * Flip REACT_APP_PAYWALL_ENABLED=true in .env to re-engage paywall.
 */
export const FEATURE_FLAGS = {
  PAYWALL_ENABLED: process.env.REACT_APP_PAYWALL_ENABLED === "true",
  ENFORCE_SUBSCRIPTION: process.env.REACT_APP_ENFORCE_SUBSCRIPTION === "true",
  SHOW_UPGRADE_PROMPTS: process.env.REACT_APP_SHOW_UPGRADE_PROMPTS === "true",
};
